import React, { useEffect, useState, useRef } from 'react';
import '../styles/Home.css';
import '../styles/Bandsintown.css';
import MyNav from './Navbar';
import PressQuotes from './PressQuotes';
import TourDateList from './bandsintownwidget/tour-date-list';
import emailjs from '@emailjs/browser';
import Footer from './Footer';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

const MOCK_UPCOMING_DATES = [
  // {
  //   id: "mock-1",
  //   datetime: "2026-10-12T20:00:00",
  //   url: "https://bellbirdband.bandcamp.com/",
  //   venue: {
  //     name: "Café Résonance",
  //     city: "Montreal",
  //     region: "QC",
  //     country: "Canada"
  //   },
  //   offers: [{ status: "available" }]
  // },
  // {
  //   id: "mock-2",
  //   datetime: "2026-10-15T20:30:00",
  //   url: "https://bellbirdband.bandcamp.com/",
  //   venue: {
  //     name: "The Rex",
  //     city: "Toronto",
  //     region: "ON",
  //     country: "Canada"
  //   },
  //   offers: [{ status: "available" }]
  // },
  // {
  //   id: "mock-3",
  //   datetime: "2026-10-20T19:30:00",
  //   url: "https://bellbirdband.bandcamp.com/",
  //   venue: {
  //     name: "Village Vanguard",
  //     city: "New York",
  //     region: "NY",
  //     country: "United States"
  //   },
  //   offers: [{ status: "sold out" }]
  // }
];

function Home() {
  // Tour Dates State
  const [tourDates, setTourDates] = useState([]);
  const [pastDates, setPastDates] = useState([]);
  const [showPastDates, setShowPastDates] = useState(false);

  // Media Facades State
  const [showVideo, setShowVideo] = useState(false);
  const [showMusic, setShowMusic] = useState(false);

  // Contact Form State
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const formRef = useRef();

  // Fetch Tour Dates (Fixed fetch loops)
  useEffect(() => {
    fetch('https://rest.bandsintown.com/artists/Bellbird/events?app_id=Test')
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(data => {
        if (Array.isArray(data)) {
          setTourDates([...MOCK_UPCOMING_DATES, ...data]);
        } else {
          setTourDates(MOCK_UPCOMING_DATES);
        }
      })
      .catch(err => {
        console.error('Error fetching upcoming dates:', err);
        setTourDates(MOCK_UPCOMING_DATES);
      });

    fetch('https://rest.bandsintown.com/artists/Bellbird/events?app_id=Test&date=past')
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(data => {
        if (Array.isArray(data)) {
          setPastDates(data);
        }
      })
      .catch(err => console.error('Error fetching past dates:', err));
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    const form = e.target;
    const isSignUpChecked = form.elements['sign-up'].checked;

    const templateParams = {
      name: form.elements['name'].value,
      email: form.elements['email'].value,
      message: form.elements['message'].value,
      'sign-up': isSignUpChecked ? 'yes' : 'no'
    };

    emailjs.send('service_7e62owq', 'template_qg3vdy9', templateParams, 'xsJKQJomrOU6aG6FS')
      .then((result) => {
        console.log('Email sent successfully:', result.text);
        form.reset();
        setSubmitSuccess(true);
      }, (error) => {
        console.error('Email send failed:', error.text);
      });
  };

  return (
    <div className="home" id="top">
      <div className="split-container">
        
        {/* Left Sticky Sidebar */}
        <aside className="left-sidebar">
          <div className="sidebar-brand-wrapper">
            <h1 className="vertical-title">Bellbird</h1>
          </div>
          <div className="sidebar-art-wrapper">
            <img 
              src={process.env.PUBLIC_URL + '/images/the-call-cover.webp'} 
              className="sidebar-cover" 
              alt="Bellbird - The Call Cover Art" 
            />
            <h2 className="album-title-text">The Call</h2>
          </div>
        </aside>

        {/* Right Scrollable Content */}
        <main className="right-content">
          <MyNav />

          {/* About Section */}
          <section id="about" className="landing-section">
            <div className="record-insert-panel">
              <img 
                src={process.env.PUBLIC_URL + '/images/Bellbird_3.webp'} 
                className="about-band-photo" 
                alt="Bellbird Band" 
              />
              <h3>About the Band</h3>
              <p className="bio-text">
                Bellbird is a collective of Montreal-based musicians comprising tenor saxophonist <a className='name-link' href='https://clairedevlin.com/' target='_blank' rel='noreferrer'>Claire Devlin</a>, alto saxophonist and bass clarinetist <a className='name-link' href='http://www.allisonburik.com/' target='_blank' rel='noreferrer'>Allison Burik</a>, bassist <a className='name-link' href='https://www.elidavidovici.com/' target='_blank' rel='noreferrer'>Eli Davidovici</a>, and drummer <a className='name-link' href='http://www.milihong.com/' target='_blank' rel='noreferrer'>Mili Hong</a>. 
              </p>
              <p className="bio-text">
                While rooted in modern jazz, Bellbird's music bears influences from myriad musical styles, from moving folk melodies, to atonal counterpoint, to rock grooves that stretch the boundaries of the jazz medium. Taking their name and sonic inspiration from the bird responsible for one of the loudest calls in the animal kingdom, they explore themes of interconnectedness between musicians, genres, and the natural world.
              </p>
              <p className="bio-text">
                Their second album and first for Constellation, <strong>The Call</strong>, draws directly from the white bellbird itself, whose extreme, distinctive cry was analyzed and woven directly into the album's title track, balancing muscular compositions with moments of space and calm.
              </p>

            </div>
          </section>

          {/* Music Section */}
          <section id="music" className="landing-section">
            <h2 className="section-title">Music & Video</h2>
            <div className="media-grid">
              
              {/* YouTube Video Section */}
              <div className="media-card">
                <h3>Featured Video: "Manakin"</h3>
                {!showVideo ? (
                  <div className="facade-container" onClick={() => setShowVideo(true)}>
                    <img 
                      src={process.env.PUBLIC_URL + '/images/manakin-preview.webp'} 
                      className="facade-artwork" 
                      alt="Manakin Video Preview" 
                    />
                    <div className="facade-overlay"></div>
                    <div className="play-button-wrapper">
                      <div className="play-icon"></div>
                    </div>
                    <span className="facade-text">Watch Live Performance</span>
                  </div>
                ) : (
                  <div className="media-iframe-wrapper">
                    <iframe 
                      style={{ width: '100%', height: '100%', border: 0 }}
                    src="https://www.youtube.com/embed/1pFZUY-jwqE?autoplay=1&controls=1" 
                      title="YouTube video player" 
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                      allowFullScreen
                    />
                  </div>
                )}
              </div>

              {/* Bandcamp Audio Section */}
              <div className="media-card">
                <h3>Listen to "The Call"</h3>
                {!showMusic ? (
                  <div className="facade-container bandcamp-facade" onClick={() => setShowMusic(true)}>
                    <img 
                      src={process.env.PUBLIC_URL + '/images/the-call-cover.webp'} 
                      className="facade-artwork" 
                      alt="The Call Cover Preview" 
                    />
                    <div className="facade-overlay"></div>
                    <div className="play-button-wrapper">
                      <div className="play-icon"></div>
                    </div>
                    <span className="facade-text">Load Bandcamp Player</span>
                  </div>
                ) : (
                  <div className="media-iframe-wrapper bandcamp-player-container">
                    <iframe 
                      style={{ border: '0', width: '100%', height: '100%' }} 
                      src="https://bandcamp.com/EmbeddedPlayer/album=97281483/size=large/bgcol=122026/linkcol=2b5c55/artwork=small/transparent=true/" 
                      seamless 
                      title="Bellbird Bandcamp Album"
                    >
                      <a href="https://bellbirdband.bandcamp.com/album/the-call">
                        The Call by Bellbird
                      </a>
                    </iframe>
                  </div>
                )}
              </div>

            </div>
          </section>

          {/* Tour Dates Section */}
          <section id="tour" className="landing-section">
            <h2 className="section-title">Tour Dates</h2>
            
            {tourDates.length > 0 ? (
              <div className="bandsintown-section">
                <h3 className="text-start mb-3" style={{ fontSize: '1.5rem', color: 'var(--accent-green)' }}>Upcoming Dates</h3>
                <TourDateList tourDates={tourDates} />
              </div>
            ) : (
              <p className="text-start py-4" style={{ fontSize: '1.2rem', color: 'rgba(234, 232, 223, 0.6)' }}>
                No upcoming tour dates currently scheduled. Check back soon!
              </p>
            )}

            {pastDates.length > 0 && (
              <div className="bandsintown-section mt-4">
                <Button 
                  onClick={() => setShowPastDates(!showPastDates)}
                  className="past-dates-toggle-btn"
                >
                  {showPastDates ? 'Hide Past Dates' : 'Show Past Dates'}
                </Button>
                
                {showPastDates && (
                  <div className="mt-4">
                    <TourDateList tourDates={pastDates} order="desc" isPast={true} />
                  </div>
                )}
              </div>
            )}
          </section>

          {/* Press Section */}
          <section id="press" className="landing-section">
            <h2 className="section-title">Press Quotes</h2>
            <div className="press-quotes-container">
              <PressQuotes />
            </div>
          </section>

          {/* Contact Section */}
          <section id="contact" className="landing-section">
            <h2 className="section-title">Contact</h2>
            <div className="contact-grid-custom">
              <div className="contact-image-wrapper">
                <img 
                  src={process.env.PUBLIC_URL + '/images/bellbird-promo-bokeh.webp'} 
                  className="contact-band-photo" 
                  alt="Bellbird Band" 
                />
              </div>
              <div className="contact-form-wrapper">
                {submitSuccess ? (
                  <div className="success-banner">
                    Success! Thank you for reaching out.
                  </div>
                ) : (
                  <Form className="contact-form" ref={formRef} onSubmit={sendEmail}>
                    <Form.Group>
                      <Form.Control 
                        type="text" 
                        placeholder="* Name" 
                        name="name" 
                        required 
                        className="form-field"
                      />
                    </Form.Group>
                    
                    <Form.Group>
                      <Form.Control 
                        type="email" 
                        placeholder="* Email" 
                        name="email" 
                        required 
                        className="form-field"
                      />
                    </Form.Group>
                    
                    <Form.Group>
                      <Form.Control 
                        as="textarea" 
                        rows={4} 
                        placeholder="Message" 
                        name="message" 
                        className="form-field"
                      />
                    </Form.Group>

                    <Form.Group className="mb-2">
                      <label className="checkbox-container">
                        <input type="checkbox" name="sign-up" defaultChecked />
                        Sign up for our mailing list to receive updates!
                      </label>
                    </Form.Group>

                    <Button type="submit" className="submit-btn">
                      Send Message
                    </Button>
                  </Form>
                )}
              </div>
            </div>
          </section>

          <Footer />
        </main>

      </div>
    </div>
  );
}

export default Home;
